import { render, staticRenderFns } from "./userDefinedModel.vue?vue&type=template&id=2fc5fe8c&scoped=true"
import script from "./userDefinedModel.vue?vue&type=script&lang=js"
export * from "./userDefinedModel.vue?vue&type=script&lang=js"
import style0 from "./userDefinedModel.vue?vue&type=style&index=0&id=2fc5fe8c&prod&lang=css"
import style1 from "./userDefinedModel.vue?vue&type=style&index=1&id=2fc5fe8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc5fe8c",
  null
  
)

export default component.exports